import { useAuth } from "../context/AuthContext";
import { PageHeader, Panel, Chip } from "../components/common/ui";
import { cn } from "../lib/utils";

const ALERT_RULES = [
  ["Revenue drops", "> 10%", true],
  ["Complaint rate increases", "> 20%", true],
  ["Hub capacity", "> 95%", true],
  ["Factory capacity", "> 90%", true],
  ["Chemical consumption above baseline", "> 10%", true],
  ["AI rejection rate", "> 15%", true],
  ["SLA below target", "< 95%", true],
  ["Quality score below target", "< 95%", false],
];

export default function SettingsPage() {
  const { user } = useAuth();
  return (
    <div data-testid="settings-page">
      <PageHeader title="Settings" subtitle="Business configuration and alert thresholds." />
      <div className="grid lg:grid-cols-2 gap-6">
        <Panel title="Account">
          <div className="space-y-3 text-sm">
            <Row k="Name" v={user?.name} />
            <Row k="Email" v={user?.email} />
            <Row k="Role" v={<Chip className="bg-primary/10 text-primary">Business Owner</Chip>} />
            <Row k="Access" v="Full business access (V1 single user)" />
          </div>
          <p className="text-xs text-slate-400 mt-4">Role-based access, location-level permissions and departmental access are planned for a future version. The data architecture is already extensible for it.</p>
        </Panel>

        <Panel title="Business">
          <div className="space-y-3 text-sm">
            <Row k="Retail Hubs" v="10 hubs across Bengaluru" />
            <Row k="Factory" v="1 central factory (Bengaluru)" />
            <Row k="Services" v="6 configurable services" />
            <Row k="AI Agents" v="Customer-Care AI · Retail AI" />
            <Row k="Currency" v="INR (₹)" />
          </div>
        </Panel>

        <Panel title="Alert Thresholds" className="lg:col-span-2" subtitle="Rules monitored by the insight & alert engine">
          <div className="grid md:grid-cols-2 gap-2">
            {ALERT_RULES.map(([rule, cond, on]) => (
              <div key={rule} className="flex items-center justify-between border border-slate-100 rounded-md px-3 py-2.5">
                <span className="text-sm text-slate-700">{rule} <span className="text-slate-400">{cond}</span></span>
                <span className={cn("w-9 h-5 rounded-full relative transition-colors", on ? "bg-secondary" : "bg-slate-200")}>
                  <span className={cn("absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all", on ? "left-4" : "left-0.5")} />
                </span>
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-center justify-between border-b border-slate-100 pb-2">
      <span className="text-slate-500">{k}</span>
      <span className="font-medium text-slate-800">{v}</span>
    </div>
  );
}
